import React from "react";
import { CBadge } from "@coreui/react";
import { TRACKING_ENDED_EXPLANATION, TRACKING_ENDED_LABEL } from "@src/utils/positionStatus";

interface Props {}

export const TrackingEndedBadge: React.FC<Props> = () => (
  <div className="TrackingEndedBadge">
    <CBadge className="TrackingEndedStatus" color="secondary">
      {TRACKING_ENDED_LABEL}
    </CBadge>
    <small className="TrackingEndedExplanation text-muted">{TRACKING_ENDED_EXPLANATION}</small>
  </div>
);
